import axios from "axios";

export class NotificationHelper {
  API_KEY = process.env.REACT_APP_ENV === "PROD" ? "HgKOabhp8q9J4yROPICxt4OwpYxSvOKWaKkMTYCs" : "P7aYQA7VD64hHmEhTifgz671akCUuwnL2oHIHOB2";
  FUNCTION_URL = process.env.REACT_APP_ENV === "PROD" ? "https://biqwotcmt5.execute-api.us-east-2.amazonaws.com/main/notification-helper" : "https://n8skh4074i.execute-api.us-west-1.amazonaws.com/sbx/notification-helper";

  async sendNotification(title, message, users) {
    try {
      return await axios.post(
        this.FUNCTION_URL,
        {
          users,
          title,
          message,
          env: process.env.REACT_APP_ENV,
        },
        {
          headers: {
            "x-api-key": this.API_KEY,
          },
        }
      );
    } catch (e) {
      console.log("error in notification : ", e);
    }
  }
}
